import { useCredentialingTranslation } from './useCredentialingTranslation';
export function useDeploymentFilters() {
    const { t } = useCredentialingTranslation();
    const deploymentFilters = (builder) => {
        builder.allFiltersPanel({
            key: '!deployment',
            label: t('filters.deployment.groupTitle'),
            children: [
                builder.allFiltersWidget({
                    label: t('filters.deployment.durationTitle'),
                    type: 'form.multiSelect',
                    key: 'deploymentDuration',
                    valueProvider: { type: 'classifier.deploymentDuration' },
                }),
                builder.allFiltersWidget({
                    label: t('filters.deployment.travelTitle'),
                    type: 'form.multiSelect',
                    key: 'deploymentTravelIds',
                    valueProvider: {
                        type: 'classifier.deploymentTravelWillingness',
                    },
                }),
            ],
        });
    };
    return { deploymentFilters };
}
